import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar =()=>{
    return (
        <nav className="navbar sticky-top navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand text-primary" to="/">
            <strong>Anime Quiz</strong>
            </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"><i className="bi bi-justify"></i></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="navbar-nav">
              <Link className="nav-link active" aria-current="page" to="/"><strong>Home</strong></Link>
              <Link className="nav-link" to="/reincarnation"><strong>Reincarnation</strong></Link>
              <Link className="nav-link" to="/adventure"><strong>Adventure</strong></Link>
              <Link className="nav-link disabled" aria-disabled="true">Coming soon</Link>
            </div>
          </div>
        </div>
      </nav>
    )
}

export default Navbar;